import { useEffect, useState } from 'react';
import { prop } from 'ramda';

import { useIsPopupManager } from 'js/components/common/PopupManager/buzz/hooks/useIsPopupManager.js';
import { useIsPageInPopupUrl } from 'js/components/system/Page/hooks';
import { useAppSelector } from 'js/store/hooks';

export const useIsShowAnyPopup = ({ delay = 0 } = {}) => {
    const isPopupManager = useIsPopupManager();
    const isPageInPopup = useIsPageInPopupUrl()();
    const isShowLocalPopup = useAppSelector(prop('isShowLocalPopup'));
    const [isShowPopup, setIsShowPopup] = useState(false);

    useEffect(() => {
        const isShowAnyPopup = isPageInPopup || isShowLocalPopup || isPopupManager;

        if (!isShowPopup || !delay) {
            setIsShowPopup(isShowAnyPopup);
            return;
        }

        // needed when the modal closes
        setTimeout(() => {
            setIsShowPopup(isShowAnyPopup);
        }, delay);
    }, [delay, isShowLocalPopup, isPageInPopup, isPopupManager, isShowPopup]);

    return isShowPopup;
};
